import { IDefineCommand } from 'core-ts-types';
import {
  PlanFeedbackGenericSlotType,
  planFeedbackTransactionActionType
} from './../builders/plan_feedback_transaction_type';
import { FeedbackSelectedLinkedSuggestionModel } from './../models/feedback_selected_linked_suggestion_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'setSelectedLinkedSuggestionCommand',
    (
      defineCommandORM: IDefineCommand,
      ngFeedbackSelectedLinkedSuggestionModel: FeedbackSelectedLinkedSuggestionModel
    ) =>
      defineCommandORM(
        'setSelectedLinkedSuggestionCommand',
        (
          deferred: any,
          nks: string[],
          resolutionIds: number[],
          type: PlanFeedbackGenericSlotType,
          action: planFeedbackTransactionActionType
        ) => {
          ngFeedbackSelectedLinkedSuggestionModel.clear().write({
            nks,
            type,
            resolutionIds,
            action
          });
          deferred.resolve();
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/set_selected_linked_suggestion_command.ts